"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectDropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@mantine/core");
var size_1 = require("../../theme/size");
var MultiSelectDropdown = function (_a) {
    var data = _a.data, _b = _a.size, size = _b === void 0 ? size_1.FieldSize.MEDIUM : _b, label = _a.label, placeholder = _a.placeholder, required = _a.required, disabled = _a.disabled, error = _a.error;
    return ((0, jsx_runtime_1.jsx)(core_1.MultiSelect, { data: data, size: size_1.mantineSizeMap.get(size), label: label, placeholder: placeholder, required: required, disabled: disabled, error: error }));
};
exports.MultiSelectDropdown = MultiSelectDropdown;
